import React, { useCallback, useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { any, head, tail, length, prop, map } from "ramda";
import { notBlank, notEmpty } from "../../util/ext";

import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import { ListItem, MenuItem, Popover } from "@mui/material";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: 0,
  },

  btn: {
    color: theme.palette.brandPrimary,
    textAlign: "left",
    fontSize: "1.6rem",
  },

  single: {
    padding: "6px 0 6px 8px",
    maxWidth: 150,
  },

  title: {
    display: "flex",
    alignItems: "center",
    padding: 0,
  },

  plus: {
    marginLeft: theme.spacing(2),
  },

  large: {
    width: 45,
    height: 45,
  },

  popup: {
    fontSize: "1.6rem",
  },
}));

const ListSummaryCard = props => {
  const {
    data,
    list,
    renderPopover,
    anchorOrigin = {
      vertical: "center",
      horizontal: "center",
    },
    transformOrigin = {
      vertical: "top",
      horizontal: "center",
    },
  } = props;
  const classes = useStyles();

  const [cell, setCell] = useState({});
  useEffect(() => {
    if (notEmpty(data)) {
      const display = prop("name", head(data));
      const plusVal = length(tail(data));
      const handleClick = prop("handleClick", head(data));

      setCell({
        display,
        plusVal,
        handleClick,
      });
    }
  }, [data, setCell]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [expanded, setExpanded] = useState(false);
  const handleClick = useCallback(event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setExpanded(true);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
    setExpanded(false);
  }, []);

  const wrapCell = (element, list) => {
    if (cell.plusVal !== 0 || any(notBlank, [list, renderPopover])) {
      return (
        <Button variant="text" className={classes.btn} onClick={handleClick}>
          {element}
        </Button>
      );
    } else if (notBlank(cell.handleClick)) {
      return (
        <Button
          variant="text"
          className={classes.btn}
          onClick={cell.handleClick}
        >
          {element}
        </Button>
      );
    } else {
      return <div className={classes.single}>{element}</div>;
    }
  };

  return (
    <Container className={classes.root} maxWidth={false}>
      {notEmpty(cell) &&
        wrapCell(
          <Tooltip title={cell.display}>
            <div className={classes.title}>
              <Typography noWrap className={classes.single}>
                {cell.display}
              </Typography>
              {cell.plusVal !== 0 && (
                <div>
                  <div className={classes.plus}>{"+" + cell.plusVal}</div>
                </div>
              )}
            </div>
          </Tooltip>,
          list,
        )}

      {notBlank(renderPopover) ? (
        renderPopover({ anchorEl, handleClose, open: expanded })
      ) : (
        <Popover
          onClick={e => e.stopPropagation()}
          className={classes.popup}
          id="item-list"
          open={expanded}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
        >
          {notBlank(list) ? (
            list
          ) : (
            <List>
              {map(item => {
                return notBlank(item.handleClick) ? (
                  <MenuItem onClick={item.handleClick} key={item.id}>
                    {item.name}
                  </MenuItem>
                ) : (
                  <ListItem key={item.id}>{item.name}</ListItem>
                );
              }, data)}
            </List>
          )}
        </Popover>
      )}
    </Container>
  );
};
export default ListSummaryCard;
